import { useEffect } from 'react';
import GeneratorInterface from './components/GeneratorInterface';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const generatorJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: 'AI Image Generator — Create Free AI Art Online',
    url: `${SITE_URL}/generator`,
    description: 'Free online AI image generator. Convert text to image or transform image to image instantly. No login required, unlimited free usage.',
    applicationCategory: 'DesignApplication',
    operatingSystem: 'Web',
    inLanguage: 'en',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
    },
    featureList: [
      'Text to Image',
      'Image to Image',
      'Batch Generation',
      'Style Transfer',
      'No Login Required',
      'Unlimited Free',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'AI Image Generator',
        item: `${SITE_URL}/generator`,
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'AI Image Generator — Free Text to Image & Image to Image Online',
    url: `${SITE_URL}/generator`,
    description: 'Use our free AI image generator to create stunning images from text or transform existing images. No login required, unlimited generations, commercial use allowed.',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Free AI Image Generator',
      url: SITE_URL,
    },
  },
];

export default function GeneratorPage() {
  useEffect(() => {
    document.title = 'AI Image Generator — Free Text to Image & Image to Image Online';

    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Use our free AI image generator to create stunning images from text or transform existing images. No login required, unlimited generations, commercial use allowed.');

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', 'AI image generator, text to image online, free image generation, image to image AI, AI art creator');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/generator`);

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', `${SITE_URL}/generator`);

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'AI Image Generator — Free Text to Image & Image to Image Online');

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Use our free AI image generator to create stunning images from text or transform existing images. No login required, unlimited generations.');

    let twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) twitterUrl.setAttribute('content', `${SITE_URL}/generator`);

    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', 'AI Image Generator — Free Text to Image & Image to Image Online');

    let lastMod = document.getElementById('last-modified-meta');
    if (lastMod) lastMod.setAttribute('content', new Date().toISOString().split('T')[0]);

    const existing = document.querySelectorAll('script[data-schema="generator"]');
    existing.forEach((s) => s.remove());

    generatorJsonLd.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'generator');
      script.setAttribute('data-index', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="generator"]').forEach((s) => s.remove());
    };
  }, []);

  return <GeneratorInterface />;
}
